module.exports = __webpack_public_path__ + "img/T1B_rc_0.3d77b28c.png";